<template>
  <v-card align="center" justify="center" light min-width="35vw" outlined>
    <v-card-title style="background-color: #d2d7e1">
      <v-list-item>
        <v-list-item-title><h2>{{ $t('createEvent') }}</h2></v-list-item-title>
        <v-spacer/>
        <v-list-item-action>
          <v-icon class="icon" icon @click="close">fa-times</v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <v-card-text class="px-7 py-7">
      <v-form v-model="valid">
        <v-container fluid>
          <v-row class="align-center mt-n2 mb-5">
            <h4 class="mr-5">{{ $t('eventDayHour') }}</h4>
            <v-divider/>
          </v-row>
          <v-row class="px-1">
            <v-text-field prepend-icon="fa-calendar" v-model="name" :rules="nameRules" :placeholder="$t('form.eventName.placeholder')" :label="$t('form.eventName.label')" counter="35" outlined/>
          </v-row>
          <v-row class="mt-n3 mx-n5">
            <v-col>
              <v-menu :clonombrese-on-content-click="false" offset-y transition="scale-transition" v-model="menuEventDate">
                <template v-slot:activator="{ on }">
                  <v-text-field prepend-icon="fa-calendar-day" @blur="eventDate = parseDate(eventDateFormatted)" :label="$t('form.eventDay.label')" :rules="dateRules" outlined persistent-hint readonly v-model="eventDateFormatted" v-on="on"/>
                </template>
                <v-date-picker @input="menuEventDate = false" no-title v-model="eventDate"/>
              </v-menu>
            </v-col>
            <v-col>
              <v-select :items="channels" prepend-icon="fa-layer-group" v-model="channel" item-text="name" item-value="id" placeholder="E.g. Wednesday Webinar" :label="$t('form.channel.label')" outlined/>
            </v-col>
          </v-row>
          <v-row class="mt-n5 mx-n5">
            <v-col>
              <v-menu ref="menu" v-model="menuEventStartTime" :close-on-content-click="false" :nudge-right="40" :return-value.sync="eventStartTime"
                      transition="scale-transition" offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field prepend-icon="fa-clock" v-model="eventStartTime" :placeholder="$t('form.eventStartTime.placeholder')" :label="$t('form.eventStartTime.label')" :rules="startTimeRules" readonly v-on="on" outlined></v-text-field>
                </template>
                <v-time-picker v-if="menuEventStartTime" v-model="eventStartTime" @click:minute="$refs.menu.save(eventStartTime)"></v-time-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-menu ref="menu2" v-model="menuEventEndTime" :close-on-content-click="false" :nudge-right="40" :return-value.sync="eventEndTime"
                      transition="scale-transition" offset-y max-width="290px" min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field prepend-icon="fa-clock" v-model="eventEndTime" :placeholder="$t('form.eventEndTime.placeholder')" :label="$t('form.eventEndTime.label')" :rules="endTimeRules" readonly v-on="on" outlined></v-text-field>
                </template>
                <v-time-picker v-if="menuEventEndTime" v-model="eventEndTime" @click:minute="$refs.menu2.save(eventEndTime)"></v-time-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row class="align-center mt-n2 my-5">
            <h4 class="mr-5">{{ $t('eventDetails') }}</h4>
            <v-divider/>
          </v-row>
          <v-row>
            <v-textarea v-model="description" :rules="descriptionRules" :placeholder="$t('form.description.placeholder')" :label="$t('form.description.label')" rows="3" auto-grow counter="280" outlined/>
          </v-row>
          <v-btn @click="addEvent" class="mb-n2">{{ $t('createEvent') }}</v-btn>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/club';
import { mapMutations } from 'vuex';
export default {
  name: "AddEvent",
  data() {
    return {
      valid: false,
      name: '',
      eventDate: new Date().toISOString().substr(0, 10),
      eventStartTime: null,
      eventEndTime: null,
      eventDateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      menuEventDate: false,
      menuEventStartTime: false,
      menuEventEndTime: false,
      channels: [],
      channel: this.$store.state.currentClubChannel.id,
      description: '',
      nameRules: [
          n => !!n || this.$t('form.eventName.rule1'),
          n => (n && n.length <= 35) || this.$t('form.eventName.rule2'),
      ],
      descriptionRules: [
          d => !!d || this.$t('form.description.rule1'),
          d => (d && d.length <= 280) || this.$t('form.description.rule2'),
      ],
      dateRules: [
          d => !!d || this.$t('form.eventDay.rule'),
      ],
      startTimeRules: [
        d => !!d || this.$t('form.eventStartTime.rule'),
      ],
      endTimeRules: [
        d => !!d || this.$t('form.eventEndTime.rule'),
      ],
    };
  },
  watch: {
    eventDate() {
      this.eventDateFormatted = this.formatDate(this.eventDate);
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.channels = [{ id: -1, name: 'GENERAL' }];
      this.$store.state.clubChannelsContributedByMe.forEach((channelContribution) => {
        this.channels.push(channelContribution.clubChannel);
      });
      this.channels.push.apply(this.channels, this.$store.state.clubPublicChannels);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    ...mapMutations(['setClubEvents']),
    addEvent() {
      if(this.valid) {
        let endTimeArray = this.eventEndTime.split(':');
        let startTimeArray = this.eventStartTime.split(':');
        let startTime = new Date(this.eventDate.substr(0, 4), this.eventDate.substr(5, 2) - 1, this.eventDate.substr(8, 2), startTimeArray[0], startTimeArray[1]);
        let endTime = new Date(this.eventDate.substr(0, 4), this.eventDate.substr(5, 2) - 1, this.eventDate.substr(8, 2), endTimeArray[0], endTimeArray[1]);

        if(startTime > endTime) {
          alert(this.$t('alerts.hourProblem'));
          return;
        }

        let event = {
          clubMember: { id: this.$store.state.clubMember.id },
          startDate: startTime,
          endDate: endTime,
          createdAt: new Date(),
          name: this.name,
          description: this.description,
        };
        if(this.channel !== -1)
          event.clubChannel = { id: this.channel };

        Repository.createClubEvent(event).then((response) => {
          if(response.status < 400) {
            alert(this.$t('alerts.created'));
            Repository.getAllClubEventsByChannel(this.$store.state.clubMember.club.id, this.$store.state.currentClubChannel.id).then((secondResponse) => {
              if(secondResponse.status < 400)
                this.setClubEvents(secondResponse.data);
            });
            this.close();
          }
        });
      }
      else
        alert(this.$t('alerts.notFilled'));
    },
    close() {
      this.$emit('closeWindow');
    },
  }
}
</script>

<style scoped>

</style>

<i18n>
{
  "en":{
    "createEvent": "Create an Event",
    "eventDayHour": "Event day and hour",
    "eventDetails": "Event details",

    "form":{
      "eventName":{
        "label": "Event Name",
        "placeholder":"E.g. Wednesday Webinar",
        "rule1":"Event name is required",
        "rule2":"Max 35 characters"
      },
      "eventDay":{
        "label": "Event Day",
        "rule": "Event day is required"
      },
      "channel":{
        "label": "Channel"
      },
      "eventStartTime":{
        "label":"Event Start Time",
        "placeholder":"E.g. 08:00",
        "rule": "Start time is required for event"
      },
      "eventEndTime":{
        "label":"Event End Time",
        "placeholder":"E.g. 11:00",
        "rule":"End time is required for event"
      },
      "description":{
        "label": "Event Description",
        "placeholder":"E.g. Weekly webinar via Zoom at https://us04web.zoom.us/",
        "rule1":"Event description is required",
        "rule2":"Max 280 characters"
      }
    },
    "alerts": {
      "notFilled": "Some fields were not filled.",
      "hourProblem": "Event can't be added.\nStart time SHOULD be before the End time.",
      "created": "Event created successfully!"
    }
  },
  "es":{
    "createEvent": "Crear Evento",
    "eventDayHour": "Día y hora del evento",
    "eventDetails": "Detalles del evento",

    "form":{
      "eventName":{
        "label": "Nombre del evento",
        "placeholder":"Ejemplo: Webinar del miércoles",
        "rule1":"El nombre del evento es obligatorio",
        "rule2":"Máximo 35 caracteres"
      },
      "eventDay":{
        "label": "Día del evento",
        "rule": "El día del evento es obligatorio"
      },
      "channel":{
        "label": "Canal"
      },
      "eventStartTime":{
        "label":"Hora de inicio del evento",
        "placeholder":"Ejemplo: 08:00",
        "rule": "La hora de inicio del evento es obligatoria."
      },
      "eventEndTime":{
        "label":"Hora de finalización del evento",
        "placeholder":"Ejemplo: 11:00",
        "rule":"La hora de finalización del evento es obligatoria"
      },
      "description":{
        "label": "Descripción del evento",
        "placeholder":"Ejemplo: Webinar semanal via Zoom en https://us04web.zoom.us/",
        "rule1":"La descripción del evento es obligatoria",
        "rule2":"Máximo 280 caracteres"
      }
    },
    "alerts": {
      "notFilled": "Algunos campos no han sido llenados aún.",
      "hourProblem": "El evento no puede ser creado.\nHora de inicio DEBE ser antes a la hora de finalización.",
      "created": "¡Evento creado satisfactoriamente!"
    }
  }
}
</i18n>
